import formatPhoneNumber from './formatPhoneNumber';
export default formatPhoneNumber;